
export class SecurityQuestion {

	code: number;
	description: string;
	type: number;
	integers: number;
	decimals: number;
	size: number;
	answer: any;
	mask: Array<any>;
	error: boolean;

	constructor() {}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/customer-service/models/security-question.ts